import { buildLxoMenu } from "routes"
import { cloneMenu } from "./helpers"
// Also available for staff-specific tweaks: overrideByKey, removeByKey, addItems

/**
 * Shared base menu for the department (staff-facing) roles.
 *
 * Mirrors backOfficeMenu.js, but built on the LXO menu instead of the admin
 * one. Each role should call this builder to get its own cloned menu instance
 * so later role-specific overrides never leak into other roles.
 */
export const buildStaffMenu = () => cloneMenu(buildLxoMenu())
